module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/personality-dark-screens-4-3.01e8179c.png";